/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Tag interface.
 */
export function instanceOfTag(value) {
    if (!('tagId' in value) || value['tagId'] === undefined)
        return false;
    if (!('keyValue' in value) || value['keyValue'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('modifiedAt' in value) || value['modifiedAt'] === undefined)
        return false;
    return true;
}
export function TagFromJSON(json) {
    return TagFromJSONTyped(json, false);
}
export function TagFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tagId': json['tagId'],
        'keyValue': json['keyValue'],
        'createdAt': (new Date(json['createdAt'])),
        'modifiedAt': (new Date(json['modifiedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'modifiedBy': json['modifiedBy'] == null ? undefined : json['modifiedBy'],
    };
}
export function TagToJSON(json) {
    return TagToJSONTyped(json, false);
}
export function TagToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tagId': value['tagId'],
        'keyValue': value['keyValue'],
        'createdAt': ((value['createdAt']).toISOString()),
        'modifiedAt': ((value['modifiedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'modifiedBy': value['modifiedBy'],
    };
}
